import React from 'react';
import { StateEvents } from '../types';
export var StateManagerContext = React.createContext({
    isLoading: true,
    carData: undefined,
    currentCarlineId: '',
    stateManager: undefined,
    stateEvent: undefined,
});
export var StateManagerProvider = function (_a) {
    var stateManager = _a.stateManager, asyncSsrManager = _a.asyncSsrManager, requestedCarFields = _a.requestedCarFields, requestedCarFieldsForUpdate = _a.requestedCarFieldsForUpdate, children = _a.children, variables = _a.variables;
    var _b = React.useState(true), isLoading = _b[0], setLoading = _b[1];
    var _c = React.useState(undefined), carData = _c[0], setCarData = _c[1];
    var _d = React.useState(undefined), stateEvent = _d[0], setStateEvent = _d[1];
    if (stateManager && !stateManager.isSubscribed()) {
        var subscribePromise = new Promise(function (resolve) {
            stateManager.subscribe(function (event, _queryVariables, configuredCarData) {
                if (event === StateEvents.FETCHING_DATA) {
                    setLoading(true);
                }
                else if (event === StateEvents.NEW_DATA) {
                    setLoading(false);
                    // This normaly should not happen, but in singleQuery mode with conflicts
                    // The query could return null while the conflict is handled
                    if (configuredCarData)
                        setCarData(configuredCarData);
                    resolve(true);
                }
                setStateEvent(event);
            }, requestedCarFields, variables, requestedCarFieldsForUpdate);
        });
        if (asyncSsrManager) {
            asyncSsrManager.scheduleRerender(subscribePromise);
        }
    }
    React.useEffect(function () {
        return function () {
            if (stateManager && stateManager.isSubscribed()) {
                stateManager.unsubscribe();
            }
        };
    }, []);
    var contextValue = React.useMemo(function () {
        return {
            isLoading: isLoading,
            carData: carData,
            stateManager: stateManager,
            currentCarlineId: stateManager.getCarlineInput().carlineId,
            stateEvent: stateEvent,
        };
    }, [isLoading, carData, stateManager, stateEvent]);
    return (React.createElement(StateManagerContext.Provider, { value: contextValue }, children));
};
//# sourceMappingURL=provider.js.map